import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class IndustryContactAdditionalContactModel extends ModelBase<IndustryContactAdditionalContactModel, IndustryContactAdditionalContactDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public industryContactId: string | undefined = "";

    @observable
    public firstName: string = "";

    @observable
    public lastName: string = "";

    @observable
    public phoneNumber: string = "";

    @observable
    public email: string = "";

    @observable
    public dateAdded: string = "";

    @observable
    public isDeleted: boolean = false;

    @observable
    public order: number = 0;
    //#endregion roperties

    @action
    public fromDto = (industryContactAdditionalContactDto: IndustryContactAdditionalContactDTO) => {
        this.id = industryContactAdditionalContactDto.id;
        this.dateAdded = industryContactAdditionalContactDto.dateAdded;
        this.isDeleted = industryContactAdditionalContactDto.isDeleted;
        this.firstName = industryContactAdditionalContactDto.firstName;
        this.lastName = industryContactAdditionalContactDto.lastName;
        this.email = industryContactAdditionalContactDto.email;
        this.phoneNumber = industryContactAdditionalContactDto.phoneNumber;
        this.industryContactId = industryContactAdditionalContactDto.industryContactId;
        this.order = industryContactAdditionalContactDto.order;
    };

    public toDto = (): IndustryContactAdditionalContactDTO => {
        return {
            id: this.id,
            dateAdded: this.dateAdded,
            email: this.email,
            firstName: this.firstName,
            industryContactId: this.industryContactId,
            isDeleted: this.isDeleted,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            order: this.order,
        };
    };
}

export interface IndustryContactAdditionalContactDTO {
    id: string | undefined;
    industryContactId?: string;
    dateAdded: string;
    isDeleted: boolean;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    order: number;
}
